import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import user_store from "../store/user_store";
import major_store from "../store/major_store";
import cohort_store from "../store/cohort_store";
import course_store from "../store/course_store";
import ExportCSV from "../functions/ExportCSV";
import AddForm_Modal from "../component/AddForm_Modal";
import YesNoAsk_Modal from "../component/YesNoAsk_Modal";
import Manage_Courseset_Modal from "../component/Manage_CourseSet_Modal";
import CurrUser from "../functions/UserAuth";
import student_store from "../store/student_store";
import supervisor_store from "../store/supervisor_store";
import admin_store from "../store/admin_store";
import courseset_store from "../store/courseset_store";
import { toast } from "react-toastify";
import styles from "../css/styles.module.css";

function Courseset_Page() {
  //#region stores

  // Student Store
  const student = student_store((state) => state.student);
  // Supervisor Store
  const supervisor = supervisor_store((state) => state.supervisor);
  // Admin Store
  const admin = admin_store((state) => state.admin);

  // courseset store
  const coursesets = courseset_store((state) => state.coursesets);
  // all coursesets
  const getcoursesets = courseset_store((state) => state.getcoursesets);
  // add courseset
  const addcourseset = courseset_store((state) => state.addcourseset);
  // edit courseset
  const editcourseset = courseset_store((state) => state.editcourseset);
  // delete courseset
  const deletecourseset = courseset_store((state) => state.deletecourseset);
  // all majors
  const majors = major_store((state) => state.majors);
  // all cohorts
  const cohorts = cohort_store((state) => state.cohorts);
  // all courses
  const courses = course_store((state) => state.courses);
  // get all courses
  const getCourses = course_store((state) => state.getCourses);
  // get all cohorts
  const getCohorts = cohort_store((state) => state.getCohorts);
  // get all majors
  const getMajors = major_store((state) => state.getMajors);

  //#endregion

  // //  let [selectValue, setSelectValue]= useState([])
  // function onSelect(actionId, id, setStatus, setClasss) {
  //   setStatus(actionId)
  //   let classvalue = actionId == 'Activated' ? 'success' : actionId == 'Deactivated' ? 'danger' : 'warning'
  //   setClasss(classvalue)
  //   putcourseset({ status: actionId }, id, currentUser?.token)
  //   //   setClasss(classvalue)
  // }

  //#region variables
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const currentUser = CurrUser(student, supervisor, admin);
  // courseset name input
  let [name, setName] = useState("");

  // short courseset rank input
  let [rank, setRank] = useState("");

  // short courseset major input
  let [major, setMajor] = useState([]);

  // short courseset cohort input
  let [cohort, setCohort] = useState([]);

  // short courseset course input
  let [course, setCourse] = useState([]);

  // courseset id
  let [id, setId] = useState(-1);

  // Add & Edit modal control
  const [isAdd, setIsAdd] = useState(false);

  // for holding data while search
  let [mydata, setMydata] = useState([]);

  // page for pagination
  const [page, setPage] = useState(1);
  // page for pagination
  const [perPage, setPerPage] = useState(10);

  //#endregion variables

  //#region functions

  // edit courseset
  const edit = (id) => {
    setId(id);
    const result = coursesets?.data?.find((courseset) => courseset.id === id);
    setRank(result.rank);
    setMajor([result.major]);
    setCohort([result.cohort]);
    setCourse([result.course]);
    setIsAdd(true);
  };
  // add courseset
  const add = (id) => {
    setId(-1);
    setName("");
    setRank("");
    setIsAdd(true);
  };
  // page pagination
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };

  // page pagination
  const handlePageChange = (page) => {
    setPage(page);
  };
  // page pagination
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  // searching data
  function onChange(e) {
    let word = e.target.value;
    const result = coursesets.data.filter(
      (courseset) =>
        courseset.course.name &&
        courseset.cohort.name &&
        courseset.major.name &&
        (courseset.rank == word ||
          courseset.course.name.toLowerCase().includes(word.toLowerCase()) ||
          courseset.cohort.name.toLowerCase().includes(word.toLowerCase()) ||
          courseset.major.name.toLowerCase().includes(word.toLowerCase())
        )
    );
    setMydata(result);

    if (word === "") {
      setMydata([]);
      setResetPaginationToggle(!resetPaginationToggle);
    }
  }

  // CSV Export
  function exportTable() {
    let arr = mydata.length > 0 ? mydata : coursesets.data;
    arr.forEach((obj, index) => (obj.id = index + 1));
    arr.forEach((obj) => (obj.major = obj?.major?.name ?? ""));
    arr.forEach((obj) => (obj.cohort = obj?.cohort?.name ?? ""));
    arr.forEach(
      (obj) =>
        (obj.created_at =
          new Date(obj?.created_at ?? "")
            ?.toLocaleString()
            ?.replace(",", "-") ?? "")
    );
    arr.forEach((obj) => (obj.course = obj?.course?.name ?? ""));
    ExportCSV(arr, "coursesets");
  }

  //#endregion functions

  //#region constructor
  useEffect(() => {
    getcoursesets();
    getMajors();
    getCohorts();
    getCourses();
  }, []);

  //#endregion constructor

  //#region Datatable column

  // selectors name should be same as in the database
  const columns = [
    {
      name: "ID",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "50px",
      id: 1,
    },
    {
      name: "Course",
      selector: (row) => row.course.name,
      sortable: true,
      id: 2,
    },
    {
      name: "Cohort",
      selector: (row) => row.cohort.name,
      width: "520px",
      id: 3,
    },
    {
      name: "Major",
      selector: (row) => row.major.name,
      id: 4,
    },
    {
      name: "Rank",
      selector: (row) => row.rank,
      width: "70px",
      id: 5,
    },
    {
      name: "Edit",
      cell: (row) => {
        return (
          <button
          onClick={function () {
            edit(row.id);
          }}
          className="btn text-white bg-primary btn-md"
          type="button"
          >
            <i className="bi bi-pencil"></i>
          </button>
        );
      },
      width: "60px",
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      name: "Delete",
      cell: (row) => {
        return (
          <button
            onClick={function () {
              handleShow();
              setId(row.id);
            }}
            className="btn text-white bg-danger btn-md"
            type="button"
          >
            <i class="bi bi-trash-fill"></i>
          </button>
        );
      },
      // width: "50px",
      ignoreRowClick: true,
      allowOverflow: true,
    },
    // {
    //   name: "Status",
    //   cell: (row) => {
    //     let classs = row.status == 'Pending' ? 'warning' : row.status == 'Activated' ? 'success' : 'danger';
    //     const status = row.status
    //     return <Selector_Component classs={classs} row={row} onSelect={onSelect} status={status} />
    //   }
    //   ,
    //   ignoreRowClick: true,
    //   allowOverflow: true,

    //   // button: true,
    // },
  ];
  //#endregion table column
  const bodyMessage =
    "Do you really want to delete? This process cannot be undone.";

  const deleteItem = async () => {
    try {
      // check and validation for name existence
      const result = await deletecourseset(id);
      // success toast appear if we succeed
      if (result?.status == 200 || result?.status == 201) {
        let msg = "Course set deleted successfully";
        toast.success(msg);
        // disappear modal
        handleClose();
        setShow(false);
        setIsAdd(false);
      }
    } catch (error) {
      const errmsg = error.response?.data?.message;
      if (!errmsg) return;
      // show error reason as an error toast
      if (Array.isArray(errmsg)) {
        errmsg.forEach((element, index) => {
          setTimeout(function () {
            toast.error(element);
          }, 200 * index);
        });
      } else {
        toast.error(errmsg);
      }
    }
  };

  //#region render
  return (
    <>
      <div className="row justify-content-between">
        <div className="col-4"></div>
        <div className="col-1"></div>
      </div>

      <div className="d-flex bd-highlight">
        <div className="pt-2 flex-grow-1 bd-highlight">
          <input
            type="text"
            onChange={(e) => onChange(e)}
            className="form-control w-50"
            placeholder="Search.."
            required
            aria-label=""
            aria-describedby="basic-addon1"
          />
        </div>
        <div className="p-2 bd-highlight  ">
          <button
            onClick={function () {
              add();
            }}
            className="btn text-white bg-primary btn-md col-12"
            type="button"
          >
            <i className="bi bi-plus-lg" aria-hidden="true"></i>
          </button>
        </div>
        <div className="p-2 bd-highlight">
          <button
            onClick={function () {
              exportTable();
            }}
            className="btn   btn-md btn btn-outline-primary"
            type="button"
          >
            CSV
          </button>
        </div>
      </div>

      {/* Datatable */}
      <DataTable
        title="coursesets"
        columns={columns}
        data={mydata?.length > 0 ? mydata : coursesets.data}
        progressPending={false}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        paginationTotalRows={
          mydata?.length > 0 ? mydata?.length : coursesets?.data?.length
        }
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        pointerOnHover
        highlightOnHover
      />

      {/* Add & Edit Modal  */}
      <Manage_Courseset_Modal
        setIsAdd={setIsAdd}
        isOpen={isAdd}
        id={id}
        addcourseset={addcourseset}
        editcourseset={editcourseset}
        token={currentUser?.token}
        name={name}
        rank={rank}
        major={major}
        allMajor={majors}
        allCohort={cohorts}
        allCourse={courses}
        cohort={cohort}
        course={course}
        setName={setName}
        setRank={setRank}
        setMajor={setMajor}
        setCohort={setCohort}
        setCourse={setCourse}
      />

      {/* Delete Modal  */}
      <YesNoAsk_Modal
        title={"Are you sure?"}
        btnName={"Delete"}
        bodyMessage={bodyMessage}
        responseMessage={"Delete"}
        variant={"danger"}
        handleClose={handleClose}
        show={show}
        submitFunc={async function () {
          deleteItem();
        }}
      />
    </>
  );
  //#endregion render
}

export default Courseset_Page;
